// Firebase Configuration
const firebaseConfig = {
  apiKey: "AIzaSyDNa_fhxyrEpERw_jOTBhowgwxzoOWnF9Y",
  authDomain: "unitedtradersweb.firebaseapp.com",
  projectId: "unitedtradersweb",
  storageBucket: "unitedtradersweb.firebasestorage.app",
  messagingSenderId: "905358882576",
  appId: "1:905358882576:web:a60d64b9613a0981dc9795",
  measurementId: "G-19QE575GHK"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const messaging = firebase.messaging();

// Service Worker Register karne ke liye (Shopify CDN link aur Scope ke sath)
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('https://cdn.shopify.com/s/files/1/0714/4259/5990/files/firebase-messaging-sw.js?v=1791556080', { scope: '/' })
    .then((registration) => {
      messaging.useServiceWorker(registration);
      console.log('Service Worker registered successfully.');
    }).catch((err) => {
      console.log('Service Worker registration failed: ', err);
    });
}

// Automatic Notification Permission Maangne ka Function (Website load hote hi)
function requestNotificationPermission() {
  Notification.requestPermission().then((permission) => {
    if (permission === 'granted') {
      console.log('Notification permission granted.');
      messaging.getToken({ vapidKey: 'BBXaMQN5G-V5M3WXcc4Ktr2iW4TWFED2KSrnb0OQrbR5z516rLZUbG37rnoKxMsFIVP3t-aqMOwagrs55p5HIag' }).then((currentToken) => {
        if (currentToken) {
          console.log('FCM Token:', currentToken);
          alert('Notification permission mil gayi! Token console mein generate ho gaya hai.');
        } else {
          console.log('No registration token available.');
        }
      }).catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
      });
    } else {
      console.log('Unable to get permission to notify.');
    }
  });
}

// Website load hone ke 3 second baad automatic popup trigger hoga
window.addEventListener('load', () => {
  setTimeout(() => {
    // Check karein ke user ne pehle se deny ya allow toh nahi kiya hua
    if (Notification.permission === 'default') {
      requestNotificationPermission();
    }
  }, 3000); // 3000 milliseconds = 3 seconds delay
});